module.exports = __webpack_public_path__ + "img/fixed-stop-point.af79d2b1.svg";